import React, { useEffect, useMemo, useState } from 'react'
import ResultsTable from '../../../components/ResultsTable'
import TargetNetSalaryCalculator from '../../../components/TargetNetSalaryCalculator'
import CalculatorChart from '../../../components/CalculatorChart'
import { useWizardStore } from '../store'
import { calculateSalaryDetails } from '../../../salaryCalculations'
import { FloatButton, Grid } from 'antd'
import { SlidersOutlined } from '@ant-design/icons'
import PensionQuickAdjustDrawer from '../components/PensionQuickAdjustDrawer'

export default function StepResults() {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const selectedTaxYear = useWizardStore((s) => s.selectedTaxYear)
  const inputs = useWizardStore((s) => s.inputs)
  const rsuEnabled = useWizardStore((s) => s.rsuEnabled)
  const { useBreakpoint } = Grid
  const screens = useBreakpoint()

  // Allow footer button (in Wizard.jsx) to open this drawer via a window event
  useEffect(() => {
    const handler = () => setDrawerOpen(true)
    window.addEventListener('openPensionDrawer', handler)
    return () => window.removeEventListener('openPensionDrawer', handler)
  }, [])

  const results = useMemo(() => {
    return calculateSalaryDetails({
      ...inputs,
      employeePensionContribution: inputs.employeePensionContribution || 0,
    }, selectedTaxYear)
  }, [inputs, selectedTaxYear])

  const hasStudentLoans = (inputs.studentLoanPlans && inputs.studentLoanPlans.length > 0)

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <h2 className="text-xl font-semibold">Results</h2>
        <p className="text-sm text-gray-600">
          This page summarises your take-home pay and tax breakdown. Toggle RSUs on/off to compare the impact.
          Your pension slider updates the calculations instantly. We’ll add a short walkthrough video here.
        </p>
      </div>

      {results && results.length > 0 && (
        <>
          <ResultsTable
            inputValues={inputs}
            selectedTaxYear={selectedTaxYear}
            rsuTaxRate={inputs.rsuTaxRate}
          />

          {rsuEnabled && (
            <TargetNetSalaryCalculator
              inputValues={inputs}
              selectedTaxYear={selectedTaxYear}
            />
          )}

          <CalculatorChart
            data={results}
            selectedTaxYear={selectedTaxYear}
            hasStudentLoans={hasStudentLoans}
          />
        </>
      )}

      <PensionQuickAdjustDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />

      {/* <FloatButton
        tooltip="Quick adjust pension %"
        icon={<SlidersOutlined />}
        type="primary"
        style={{ right: screens.xs ? 16 : 24, bottom: screens.xs ? 80 : 24 }}
        onClick={() => setDrawerOpen(true)}
      /> */}
    </div>
  )
} 